import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { getCookie } from '../../../utils/getCookies';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-compass-buy',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, TranslateModule],
  templateUrl: './compass-buy.component.html',
  styleUrl: './compass-buy.component.scss'
})
export class CompassBuyComponent {


  @Input() is_from_ad: boolean = false;
  @Output() link_output: EventEmitter<string> = new EventEmitter<string>();

  private _quantity: number = 1;

  get quantity(): number {
    return this._quantity;
  }

  set quantity(value: number) {
    this._quantity = Math.max(1, Math.min(10, value || 1));
  }
  licencesPrices: any = {};
  email: string = '';
  is_from_validate_email: boolean = false;
  additional_licenses: boolean = false;
  isTokenValid: boolean | null = null;
  error_validation: boolean = false;
  token: string = '';
  licenceFallback: boolean = false;
  is_offer: boolean = false;

  constructor(private http: HttpClient, private route: ActivatedRoute, private translate: TranslateService) {

    this.route.queryParams.subscribe((params: any) => {
      this.is_offer = params['is_offer'] === true
        || params['is_offer'] === 'true'
        || params['is_offer'] === '1'
        || (params['is_offer'] !== undefined && params['is_offer'] !== 'false' && params['is_offer'] !== '0' && params['is_offer'] !== false);

      if (params['token']) {
        this.token = params['token'];
        this.verifyToken(params['token']);
      }
      else{
        this.getLicenses();
      }


      if (params['additional_licenses'] && (params['additional_licenses'] === '1' || params['additional_licenses'] === 1)) {
        this.additional_licenses = true;
      }

    });

  }

  get monthlyPricePerUser(): number {
    return this.is_offer ? 74.99 : 250;
  }

  get monthlyTotalPrice(): number {
    return this.is_offer ? 74.99 * 12 * this.quantity : 3000 * this.quantity;
  }

  onQuantityChange(event: any) {
    const value = parseInt(event.target.value, 10);
    if (isNaN(value) || value < 1) {
      this.quantity = 1;
      event.target.value = '1';
    } else if (value > 10) {
      this.quantity = 10;
      event.target.value = '10';
    } else {
      this.quantity = value;
    }
  }

  getLicenses() {
    const offerQuery = this.is_offer ? '?is_offer=true' : '';

    if (getCookie("access_token") && !this.licenceFallback){
      const headers = {
        headers: {
          Authorization: `Bearer ${getCookie('access_token')}`
        }
      };
  
      this.http.get(`${environment.url}/api/v1/payments/get_licences_prices_and_email${offerQuery}`, headers).subscribe({
        next: (response: any) => {
          console.log('Licences prices:', response);
          this.licencesPrices = response.prices;
          this.email = response.email;
        },
        error: (error) => {
          console.error('Error fetching licences prices:', error);
          this.licenceFallback = true;
          this.getLicenses();
        }
      });

    }
    else{

      this.http.get(`${environment.url}/api/v1/payments/get_licences_prices_and_email_ad${offerQuery}`).subscribe({
        next: (response: any) => {
          console.log('Licences prices:', response);
          this.licencesPrices = response.prices;
        },
        error: (error) => {
          console.error('Error fetching licences prices:', error);
        }
      });

    }


  }

  buyCompass(type: string) {
    console.log('Comprar');
    let type_bought_licenses = '';
    let plan_price_bought_licenses = 0;
    if (type == 'anual') {
      (window as any).dataLayer.push({ 
        event: "plan_selected",
        plan_name: "Plan Anual",     // Tipo de plan
        plan_price: 190 * this.quantity,     // Precio final del plan
        users: this.quantity,     // Cantidad de usuarios que han contratado 
      });
      type_bought_licenses = 'Plan Anual';
      plan_price_bought_licenses = 190 * this.quantity;
    }
    else{
      const monthlyPrice = this.monthlyPricePerUser * this.quantity;
      (window as any).dataLayer.push({ 
        event: "plan_selected",
        plan_name: "Plan Mensual",     // Tipo de plan
        plan_price: monthlyPrice,     // Precio final del plan
        users: this.quantity,     // Cantidad de usuarios que han contratado 
      });
      type_bought_licenses = 'Plan Mensual';
      plan_price_bought_licenses = monthlyPrice;
    }

    const priceEntry = this.licencesPrices.find((item: any) => item.number_licences === this.quantity && item.type === type);
    if (priceEntry && priceEntry.link) {

      localStorage.setItem('quantity_bought_licenses', this.quantity.toString());
      localStorage.setItem('type_bought_licenses', type_bought_licenses);
      localStorage.setItem('plan_price_bought_licenses', plan_price_bought_licenses.toString());

      if (this.is_from_ad) {
        const link_output = priceEntry.link + '?locked_prefilled_email=' + this.email;
        this.link_output.emit(link_output);
      } else {
        window.location.href = priceEntry.link + '?locked_prefilled_email=' + this.email;
      }
    } else {
      console.error('No URL found for the selected quantity of licences');
    }
  }


  verifyToken(token: string) {
    this.http.get(`${environment.url}/api/company/verify_email?token=${token}`)
      .pipe(
        catchError(() => of(false))
      )
      .subscribe((response: any) => {
        console.log("response de la trucada",response)
        if (response) {
          this.error_validation = false;
          this.is_from_validate_email = true;
          this.isTokenValid = true;
          document.cookie = `access_token=${response.access_token}; path=/;`;
          document.cookie = `company_name=${response.company_name}; path=/;`;
          this.getLicenses();
        } else {
          this.isTokenValid = false;
          this.is_from_validate_email = true;
          this.error_validation = true;
        }
      });
  }

}
